import { render } from "./OpenSourceModels.vue?vue&type=template&id=216cf306&scoped=true"
import script from "./OpenSourceModels.vue?vue&type=script&lang=js"
export * from "./OpenSourceModels.vue?vue&type=script&lang=js"

import "./OpenSourceModels.vue?vue&type=style&index=0&id=216cf306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216cf306"]])

export default __exports__